import { useAuth } from '@/context/AuthContext';
import { useHousePermissions } from '@/hooks/useHasPermission';

export const useImportantSystemsPermissions = () => {
	const { isSuperAdmin } = useAuth();
	const { canUploadDocuments, canDeleteDocuments } = useHousePermissions();

	return {
		canEdit: canUploadDocuments || isSuperAdmin,
		canRemove: canDeleteDocuments || isSuperAdmin,
	};
};
